/**
 * Language tier classification — the frontend's single source of truth.
 *
 * TIER1 = the 23 EU official languages the corpus targets (en is the source
 * language). TIER2 = partner languages — zh-CN is a PARTNER language, not an
 * EU official one.
 *
 * The backend (@polyglot/qc-review/languages, polyglot.js) carries its own
 * copy of these lists and returns a `tier` field per row. Do NOT group by
 * that field: the deployed backend can lag this classification (the zh-CN
 * mislabel, 2026-07-04, sat in the live backend while the fix waited on the
 * Phase-3 brain code update). All frontend grouping derives from THIS file;
 * cross-source single-sourcing (DB-driven tiers) is recorded future work.
 */
export const TIER1 = [
  'bg', 'cs', 'da', 'de', 'el', 'es', 'et', 'fi', 'fr', 'ga', 'hr', 'hu',
  'it', 'lt', 'lv', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'sl', 'sv',
];

export const TIER2 = ['eu', 'ca', 'ja', 'pt-BR', 'ko', 'th', 'hi', 'ta', 'zh-CN'];
